/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class ProjectDataManagerControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation projectDataManagerControllerCreateAll
   */
  static readonly ProjectDataManagerControllerCreateAllPath = '/project-data-manager/bulk/{dataTableName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAll$Response(params: {
    dataTableName: string;
    body?: Array<{ [key: string]: any }>
  }): Observable<StrictHttpResponse<Array<{ [key: string]: any }>>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectDataManagerControllerService.ProjectDataManagerControllerCreateAllPath, 'post');
    if (params) {
      rb.path('dataTableName', params.dataTableName, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<{ [key: string]: any }>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAll(params: {
    dataTableName: string;
    body?: Array<{ [key: string]: any }>
  }): Observable<Array<{ [key: string]: any }>> {

    return this.createAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<{ [key: string]: any }>>) => r.body as Array<{ [key: string]: any }>)
    );
  }

  /**
   * Path part for operation projectDataManagerControllerFindById
   */
  static readonly ProjectDataManagerControllerFindByIdPath = '/project-data-manager/{dataTableName}/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    dataTableName: string;
    id: string;
    filter?: string;
  }): Observable<StrictHttpResponse<{ [key: string]: any }>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectDataManagerControllerService.ProjectDataManagerControllerFindByIdPath, 'get');
    if (params) {
      rb.path('dataTableName', params.dataTableName, {});
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{ [key: string]: any }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    dataTableName: string;
    id: string;
    filter?: string;
  }): Observable<{ [key: string]: any }> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<{ [key: string]: any }>) => r.body as { [key: string]: any })
    );
  }

  /**
   * Path part for operation projectDataManagerControllerDeleteById
   */
  static readonly ProjectDataManagerControllerDeleteByIdPath = '/project-data-manager/{dataTableName}/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    dataTableName: string;
    id: string;
  }): Observable<StrictHttpResponse<Array<{ [key: string]: any }>>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectDataManagerControllerService.ProjectDataManagerControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('dataTableName', params.dataTableName, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<{ [key: string]: any }>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    dataTableName: string;
    id: string;
  }): Observable<Array<{ [key: string]: any }>> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<Array<{ [key: string]: any }>>) => r.body as Array<{ [key: string]: any }>)
    );
  }

  /**
   * Path part for operation projectDataManagerControllerUpdateById
   */
  static readonly ProjectDataManagerControllerUpdateByIdPath = '/project-data-manager/{dataTableName}/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    dataTableName: string;
    id: string;
    body?: { [key: string]: any }
  }): Observable<StrictHttpResponse<Array<{ [key: string]: any }>>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectDataManagerControllerService.ProjectDataManagerControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('dataTableName', params.dataTableName, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<{ [key: string]: any }>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    dataTableName: string;
    id: string;
    body?: { [key: string]: any }
  }): Observable<Array<{ [key: string]: any }>> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<Array<{ [key: string]: any }>>) => r.body as Array<{ [key: string]: any }>)
    );
  }

  /**
   * Path part for operation projectDataManagerControllerFind
   */
  static readonly ProjectDataManagerControllerFindPath = '/project-data-manager/{dataTableName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params: {
    dataTableName: string;
    filter?: string;
  }): Observable<StrictHttpResponse<Array<{ [key: string]: any }>>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectDataManagerControllerService.ProjectDataManagerControllerFindPath, 'get');
    if (params) {
      rb.path('dataTableName', params.dataTableName, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<{ [key: string]: any }>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params: {
    dataTableName: string;
    filter?: string;
  }): Observable<Array<{ [key: string]: any }>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<{ [key: string]: any }>>) => r.body as Array<{ [key: string]: any }>)
    );
  }

  /**
   * Path part for operation projectDataManagerControllerCreate
   */
  static readonly ProjectDataManagerControllerCreatePath = '/project-data-manager/{dataTableName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params: {
    dataTableName: string;
    body?: { [key: string]: any }
  }): Observable<StrictHttpResponse<{ [key: string]: any }>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectDataManagerControllerService.ProjectDataManagerControllerCreatePath, 'post');
    if (params) {
      rb.path('dataTableName', params.dataTableName, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{ [key: string]: any }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params: {
    dataTableName: string;
    body?: { [key: string]: any }
  }): Observable<{ [key: string]: any }> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<{ [key: string]: any }>) => r.body as { [key: string]: any })
    );
  }

}
